import React, { useEffect } from 'react';

const WHATSAPP_LINK = 'https://wa.me/447386375420';
const TELEGRAM_LINK = 'https://t.me/izziefoxx';

function ServicePage({ title, seoTitle, description, heroText, sections, icon, pricingText, ctaHeading, ctaText }) {
  useEffect(() => {
    document.title = seoTitle;
    window.scrollTo(0, 0);
  }, [seoTitle]);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm border-b" style={{borderColor: '#EBBEDA'}}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <a href="/" className="text-2xl font-bold" style={{color: '#EBBEDA'}}>Izzie Fox</a>
            <div className="flex items-center gap-6">
              <a href="/services" className="text-gray-700 hover:text-pink-400 font-medium">All Services</a>
              <a href="/#gallery" className="text-gray-700 hover:text-pink-400 font-medium">Gallery</a>
              <a href="/verify" className="text-gray-700 hover:text-pink-400 font-medium">Verification</a>
              <a href="/#contact" className="text-gray-700 hover:text-pink-400 font-medium">Contact</a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="pt-24 pb-16" style={{background: 'linear-gradient(135deg, #FAF8FB 0%, #FFFFFF 50%, #F5F0F6 100%)'}}>
        <div className="max-w-4xl mx-auto px-4 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full mb-6" style={{background: '#EBBEDA'}}>
            <span className="text-4xl">{icon}</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            <span style={{color: '#EBBEDA'}}>{title}</span>
          </h1>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">{heroText}</p>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4">
          {sections.map((section, idx) => (
            <div key={section.heading} className="mb-12">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">
                <span style={{color: '#EBBEDA'}}>{section.heading}</span>
              </h2>
              {section.paragraphs.map((p, i) => (
                <p key={`${section.heading}-p-${i}`} className="text-gray-600 text-lg mb-4 leading-relaxed">{p}</p>
              ))}
            </div>
          ))}

          {/* Pricing */}
          <div className="bg-gradient-to-r from-pink-50 to-white rounded-3xl p-8 md:p-10 shadow-lg border-2 mb-12" style={{borderColor: '#EBBEDA'}}>
            <h2 className="text-2xl font-bold text-gray-800 mb-3">Pricing</h2>
            <p className="text-gray-600 text-lg">{pricingText || "Contact me for current pricing and availability. I'm always happy to discuss what works for you."}</p>
          </div>

          {/* CTA */}
          <div className="text-center space-y-4">
            <h2 className="text-2xl font-bold text-gray-800 mb-2">{ctaHeading || 'Ready to get started?'}</h2>
            {ctaText && <p className="text-gray-600 text-lg mb-4">{ctaText}</p>}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-green-500 text-white font-bold rounded-full transition-all hover:scale-105 shadow-lg"
                data-testid="service-whatsapp-cta"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>
                WhatsApp Me
              </a>
              <a
                href={TELEGRAM_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 text-white font-bold rounded-full transition-all hover:scale-105 shadow-lg"
                style={{background: '#0088cc'}}
                data-testid="service-telegram-cta"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0a12 12 0 00-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 01.171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
                Telegram @izziefoxx
              </a>
            </div>
            <a href="/services" className="inline-block text-gray-500 hover:text-gray-700 mt-6">← Back to all services</a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t-2 py-6" style={{borderColor: '#EBBEDA'}}>
        <div className="max-w-7xl mx-auto px-4 text-center text-gray-500 text-sm">
          <p><a href="/" className="font-bold text-gray-800">Izzie <span style={{color: '#EBBEDA'}}>Fox</span></a></p>
          <p className="mt-1">© 2026 Izzie Fox. All rights reserved. | 18+ Content | <a href="https://linktr.ee/IzzieFox" target="_blank" rel="noopener noreferrer" style={{color: '#EBBEDA'}}>Linktree</a></p>
        </div>
      </footer>
    </div>
  );
}

export default ServicePage;
